var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, thunk } from 'easy-peasy';
import { API_BASE_URL } from '../config/api';
import { isLocalLoginMode, getDummyShareCodeSections } from '../helper/localLoginMode';
// Rewrite the backend-supplied "ungrouped" group's display title to
// "Uncategorized". The id stays as `ungrouped` so the API endpoints that
// reference it (move-to / delete / etc.) still target the right group.
var relabelUngrouped = function (sections) {
    return sections.map(function (section) {
        return section.id === 'ungrouped' ? __assign(__assign({}, section), { titleKey: 'text.uncategorized' }) : section;
    });
};
/**
 * Drop codes the user minted with **Share**, never with Save.
 *
 * Share has to persist the workspace to make the code resolve to anything, so
 * the record exists server-side and `GET /share-codes` may return it. Filtering
 * here — rather than in the panel — is what makes every consumer agree: the
 * saved-work list, the Save-As folder picker, the move-to targets and the
 * bulk-select actions all read this slice, and a row that is hidden in one and
 * selectable in another is worse than either behaviour on its own.
 *
 * Explicit `=== true`, so a record that omits the field (an older server, a
 * test fixture) stays visible. Hiding a user's saved work because a field is
 * missing is the one failure mode that loses work; showing a shared code that
 * should have been hidden is merely the behaviour we have today.
 */
var dropShareOnly = function (sections) {
    return sections.map(function (section) { return (__assign(__assign(__assign({}, section), (section.entries ? { entries: section.entries.filter(function (e) { return e.shareOnly !== true; }) } : {})), (section.children ? { children: dropShareOnly(section.children) } : {}))); });
};
var groupsStore = {
    sections: [],
    loading: false,
    loaded: false,
    setSections: action(function (state, payload) {
        state.sections = payload;
    }),
    setLoading: action(function (state, payload) {
        state.loading = payload;
    }),
    setLoaded: action(function (state, payload) {
        state.loaded = payload;
    }),
    fetchGroups: thunk(function (actions) { return __awaiter(void 0, void 0, void 0, function () {
        var ok, res, body, candidate, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Local dev "logged-in" mode: seed the saved-work list with dummy share
                    // codes instead of hitting the (absent) backend. No-op off localhost.
                    if (isLocalLoginMode()) {
                        // Through the same filter as the real response — the seed carries a
                        // share-only row precisely so this rule is exercisable offline.
                        actions.setSections(dropShareOnly(getDummyShareCodeSections()));
                        actions.setLoaded(true);
                        return [2 /*return*/];
                    }
                    actions.setLoading(true);
                    ok = false;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch("".concat(API_BASE_URL, "share-codes"), { credentials: 'include' })];
                case 2:
                    res = _c.sent();
                    if (!res.ok) {
                        actions.setSections([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, res.json().catch(function () { return null; })];
                case 3:
                    body = _c.sent();
                    candidate = (_b = body === null || body === void 0 ? void 0 : body.data) !== null && _b !== void 0 ? _b : body;
                    actions.setSections(Array.isArray(candidate) ? dropShareOnly(relabelUngrouped(candidate)) : []);
                    ok = true;
                    return [3 /*break*/, 6];
                case 4:
                    _a = _c.sent();
                    actions.setSections([]);
                    return [3 /*break*/, 6];
                case 5:
                    actions.setLoading(false);
                    if (ok)
                        actions.setLoaded(true);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }),
};
export default groupsStore;
